import { decodeClickContextUnverified, looksLikeClickContext } from './click-context-decode'

/** Carry the original comparison reporting token, never mint or verify it in
 * the browser. The retailer redirect remains the signature trust boundary.
 * No cookies, storage, user identifiers, or affiliate URL construction. */
export function comparisonHrefWithContext(href: string, token: string | null, fin?: string | null): string {
  if (!looksLikeClickContext(token)) return href
  const context = decodeClickContextUnverified(token)
  if (!context || context.channel !== 'chatgpt' || context.surface !== 'appliance-comparison' ||
      context.tool !== 'compare_refrigerators' || context.trace !== null) return href
  const age = Date.now() / 1000 - context.issuedAt
  if (!Number.isFinite(age) || age < -300 || age > 72 * 3600) return href
  try {
    const url = new URL(href, 'https://fridge.com')
    if (url.origin !== 'https://fridge.com' || url.username || url.password || href.startsWith('//')) return href
    const product = /^\/products\/[a-z0-9]+(?:-[a-z0-9]+)*$/.test(url.pathname)
    const comparison = /^\/compare(?:\/[a-z0-9]+(?:-[a-z0-9]+)*)?$/.test(url.pathname)
    if (!product && !comparison) return href
    const suffix = /-fin(\d{7})$/.exec(url.pathname)
    const destinationFin = fin ?? (suffix ? `FIN-${suffix[1]}` : null)
    if (suffix && fin && fin !== `FIN-${suffix[1]}`) return href
    if (context.fin !== null && (!product || context.fin !== destinationFin)) return href
    if (url.searchParams.has('cx')) return href
    // Preserve the destination bytes and fragment, including chooser order.
    const hash = href.indexOf('#')
    const base = hash === -1 ? href : href.slice(0, hash)
    return `${base}${base.includes('?') ? '&' : '?'}cx=${encodeURIComponent(token)}${hash === -1 ? '' : href.slice(hash)}`
  } catch { return href }
}
